module.exports = __webpack_public_path__ + "img/jsdx.8bfd5edb.png";